const GenralStatsReduser = (state = [], action) => {
    switch (action.type) {
        case 'GENRAL_STATS_SUCCESS':
            return action.payload.res.data
        default:
            return state
    }
}
export default GenralStatsReduser